import { BrandCaptionLowerThirdEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdDeleteRequestDTO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdDeleteRequest) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdDeleteRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "caption"],
      properties: {
        roomId,
        caption: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThirdDeleteRequest {
  roomId: RoomId;
  caption: BrandCaptionLowerThirdEntity;
}
